import styled from 'styled-components';
import { Box } from '@lifechurch/react-ion';

interface ModalButtonProps {
  color: string;
}

export const Bold = styled.span`
  font-weight: bold;
`;

export const StyledLink = styled(Box)`
  color: ${(props): string => props.theme.colors.gray50};
  font-size: ${(props): string => props.theme.fontSizes[3]};
  line-height: ${(props): number => props.theme.lineHeights[2]}rem;
  width: fit-content;
  margin-bottom: 5px;

  &:hover,
  &:focus {
    color: ${props => props.theme.colors.gray100};
    cursor: pointer;
  }
`;

export const ModalButton = styled.button<ModalButtonProps>`
  margin: 16px 0 0 16px;
  padding: 0;
  outline: none;
  border: none;
  background: none;
  font-weight: 600;
  color: ${(props): string => props.color};
  font-size: ${(props): string => props.theme.fontSizes[3]};

  &:hover {
    cursor: pointer;
  }
`;
